export enum ExpenseTypeEnum {
    Corrente = 1,
    Capital = 2
}
